import { render, staticRenderFns } from "./RegistryResponseView.vue?vue&type=template&id=0dfdc261&"
import script from "./RegistryResponseView.vue?vue&type=script&lang=js&"
export * from "./RegistryResponseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports